import { useQuery } from '@tanstack/react-query';
import { TEN_MINUTES } from 'config/constants';
import { getSelectedPropertyId } from 'core/core.selectors';
import { LoadPropertyDataSuccess, SetPropertyBasicDataIsLoaded } from 'entities/property/property.actions';
import { getPropertySelectedInfoBasic } from 'entities/property/property.selectors';
import { transformPropertyData } from 'entities/property/property.service';
import { isEmpty } from 'lodash';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropertyQueryType } from './property.models';
import { getPropertyBasicInfo } from './property.service';

export const useGetPropertyBasicInfo = () => {
  const property = useSelector(getSelectedPropertyId);
  const dispatch = useDispatch();
  const propertySelectedInfoBasic = useSelector(getPropertySelectedInfoBasic);

  const isPropertyDataNotLoaded = useMemo(
    () => isEmpty(propertySelectedInfoBasic) || property !== propertySelectedInfoBasic.id,
    [property, propertySelectedInfoBasic]
  );

  useEffect(() => {
    if (isPropertyDataNotLoaded) {
      dispatch(SetPropertyBasicDataIsLoaded(false));
    }
  }, [dispatch, isPropertyDataNotLoaded]);

  const { data } = useQuery(
    [PropertyQueryType.GET_PROPERTY_BASIC_INFO, property],
    () =>
      getPropertyBasicInfo({
        property_id: property!
      }),
    {
      staleTime: TEN_MINUTES,
      enabled: !!property
    }
  );

  useEffect(() => {
    if (!data) return;
    dispatch(LoadPropertyDataSuccess(transformPropertyData(data)));
  }, [data, dispatch]);
};
